import { useContext, useState } from 'react';
import { AbilityContext } from '../../../context/AbilityContext';
import MainBusinessPaymentPage from '../business-central';
import PaymentForm from './paymentForm';
interface Props {
  setShowSummary: any;
  setShowPayment: any;
  setCurrentShipmentStatus: any;
}
function MainPaymentPage({
  setShowSummary,
  setCurrentShipmentStatus,
  setShowPayment,
}: Props) {
  const ability = useContext(AbilityContext);
  const [isBusinessUser, setIsBusinessUser] = useState(
    ability.can('create', 'Business Central')
  );
  return (
    <div>
      {isBusinessUser ? (
        <MainBusinessPaymentPage
          setShowSummary={setShowSummary}
          setShowPayment={setShowPayment}
          setCurrentShipmentStatus={setCurrentShipmentStatus}
        />
      ) : (
        <PaymentForm
          setShowSummary={setShowSummary}
          setShowPayment={setShowPayment}
          setCurrentShipmentStatus={setCurrentShipmentStatus}
        />
      )}
    </div>
  );
}

export default MainPaymentPage;
